(function () {
  'use strict';

  var TRACKER_VERSION = '1.4-horizon-3.5.1-final';
  var DEBUG = true;

  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  var state = {
    startedAt: Date.now(),
    maxScrollDepth: 0,
    scrollMilestonesHit: [],
    sectionsSeen: {},
    sectionVisits: {},
    activeSections: {},
    priceSeen: false,
    timeToPriceS: null,
    variantSelected: false,
    variantChangeCount: 0,
    sessionEnded: false
  };

  var SCROLL_MILESTONES = [25, 50, 75, 90, 100];
  var SECTION_DWELL_MS = 800;

  var SECTION_DEFS = [
    {
      id: 'hero',
      name: 'Product Gallery',
      order: 1,
      selectors: [
        '[data-th-section-id="hero"]',
        '[data-testid="product-information-media"]',
        '.product-information__media',
        'media-gallery',
        'product-gallery',
        '.product-media',
        '.product__media-wrapper'
      ]
    },
    {
      id: 'product_details',
      name: 'Product Details',
      order: 2,
      selectors: [
        '.product-information__content',
        '.product-information__details',
        '.product__info-container',
        '.product__info-wrapper',
        '[data-testid="product-information-details"]',
        '.product-details'
      ]
    },
    {
      id: 'price_block',
      name: 'Price',
      order: 3,
      selectors: [
        'product-price',
        '.price',
        '.product__price',
        '.product-price',
        '[data-testid="price"]',
        '[data-price]',
        '[class*="price"]'
      ]
    },
    {
      id: 'variant_selector',
      name: 'Variant Selector',
      order: 4,
      selectors: [
        'variant-picker-component',
        'variant-picker',
        '.variant-picker',
        '.product-form__input',
        '[data-option-name]',
        '[data-testid*="variant"]'
      ]
    },
    {
      id: 'buy_buttons',
      name: 'Buy Buttons',
      order: 5,
      selectors: [
        'buy-buttons-component',
        '.buy-buttons',
        '.product-form__buttons',
        'product-form',
        'form[action*="/cart/add"] button[type="submit"]',
        '[name="add"]'
      ]
    },
    {
      id: 'trust_badges',
      name: 'Trust Badges',
      order: 6,
      selectors: [
        '[data-th-section-id="trust_badges"]',
        '[data-th-trust-asset]',
        '.trust-badge',
        '.trust-badges',
        '.icon-with-text',
        '.group-block'
      ]
    },
    {
      id: 'product_accordion',
      name: 'Product Info Accordion',
      order: 7,
      selectors: [
        'accordion-component',
        'details',
        '.accordion',
        '.product__accordion',
        '[data-testid*="accordion"]',
        'collapsible-row'
      ]
    },
    {
      id: 'related_products',
      name: 'Related Products',
      order: 8,
      selectors: [
        'product-recommendations',
        '.product-recommendations',
        '.related-products',
        '[data-testid*="recommendations"]',
        '[data-section-type*="recommendations"]'
      ]
    }
  ];

  function log() {
    if (!DEBUG) return;

    if (window.console && console.log) {
      console.log.apply(
        console,
        ['[ud-tracker]'].concat(Array.prototype.slice.call(arguments))
      );
    }
  }

  function nowS() {
    return Math.round((Date.now() - state.startedAt) / 100) / 10;
  }

  function getDeviceType() {
    return window.innerWidth < 768 ? 'mobile' : 'desktop';
  }

  function getScrollDepth() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;

    var docHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );

    var winHeight = window.innerHeight || document.documentElement.clientHeight;
    var scrollable = Math.max(docHeight - winHeight, 1);

    return Math.min(100, Math.round((scrollTop / scrollable) * 100));
  }

  function baseProps() {
    return {
      schema_version: TRACKER_VERSION,
      page_url: window.location.href,
      pathname: window.location.pathname,
      device_type: getDeviceType(),
      viewport_width: window.innerWidth,
      viewport_height: window.innerHeight,
      scroll_depth_percent: getScrollDepth(),
      time_on_page_s: nowS()
    };
  }

  function capture(eventName, props) {
    var payload = Object.assign({}, baseProps(), props || {});

    if (window.posthog && typeof window.posthog.capture === 'function') {
      window.posthog.capture(eventName, payload);
      log('captured:', eventName, payload);
    } else {
      log('posthog not ready:', eventName, payload);
    }
  }

  function findElement(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      try {
        var el = document.querySelector(selectors[i]);
        if (el) return el;
      } catch (e) {}
    }

    return null;
  }

  function getSectionElements() {
    var found = [];
    var missing = [];

    SECTION_DEFS.forEach(function (def) {
      var el = findElement(def.selectors);

      if (el) {
        el.setAttribute('data-ud-section-id', def.id);
        el.setAttribute('data-ud-section-name', def.name);
        el.setAttribute('data-ud-section-order', def.order);

        found.push({
          def: def,
          el: el
        });
      } else {
        missing.push(def.id);
      }
    });

    log(
      'Sections observed:',
      found.map(function (x) {
        return x.def.id;
      })
    );

    log('Sections NOT found in DOM:', missing);

    return found;
  }

  function extractPriceText() {
    var selectors = [
      'product-price',
      '.price',
      '.product__price',
      '.product-price',
      '[data-testid="price"]',
      '[class*="price"]'
    ];

    var el = findElement(selectors);

    if (!el) return null;

    return el.textContent || '';
  }

  function extractPriceNumber() {
    var text = extractPriceText();

    if (!text) return null;

    var cleaned = text
      .replace(/,/g, '')
      .replace(/[^\d.]/g, ' ')
      .trim();

    var match = cleaned.match(/\d+(\.\d+)?/);

    if (!match) return null;

    var value = parseFloat(match[0]);

    return isNaN(value) ? null : value;
  }

  function getPriceBand(price) {
    if (price === null || price === undefined) return null;
    if (price < 500) return 'under_500';
    if (price < 1000) return '500_1000';
    if (price < 1500) return '1000_1500';
    if (price < 2500) return '1500_2500';
    if (price < 5000) return '2500_5000';

    return 'above_5000';
  }

  function sectionProps(def) {
    var price = extractPriceNumber();

    return {
      section_id: def.id,
      section_name: def.name,
      section_order: def.order,
      section_visit_count: state.sectionVisits[def.id] || 0,
      visible_dwell_ms: SECTION_DWELL_MS,
      price_already_seen: state.priceSeen,
      sections_seen_count: Object.keys(state.sectionsSeen).length,
      price_displayed: price,
      price_band: getPriceBand(price)
    };
  }

  function setupSectionObserver(items) {
    if (!('IntersectionObserver' in window)) {
      log('IntersectionObserver not supported');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var el = entry.target;
          var id = el.getAttribute('data-ud-section-id');

          var def = SECTION_DEFS.find(function (x) {
            return x.id === id;
          });

          if (!def) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            if (!state.activeSections[id]) {
              state.activeSections[id] = {
                enteredAt: Date.now(),
                timer: null
              };

              state.activeSections[id].timer = setTimeout(function () {
                state.sectionVisits[id] = (state.sectionVisits[id] || 0) + 1;

                var eventName = state.sectionsSeen[id]
                  ? 'pdp section revisited'
                  : 'pdp section seen';

                state.sectionsSeen[id] = true;

                capture(eventName, sectionProps(def));

                if (id === 'price_block' && !state.priceSeen) {
                  firePriceSeen();
                }
              }, SECTION_DWELL_MS);
            }
          } else {
            if (state.activeSections[id]) {
              var active = state.activeSections[id];

              if (active.timer) {
                clearTimeout(active.timer);
              }

              var visibleDwell = Date.now() - active.enteredAt;

              if (visibleDwell > 300) {
                capture('pdp section exited', {
                  section_id: id,
                  section_name: def.name,
                  section_order: def.order,
                  visible_dwell_ms: visibleDwell,
                  total_dwell_ms: visibleDwell,
                  section_visit_count: state.sectionVisits[id] || 0
                });
              }

              delete state.activeSections[id];
            }
          }
        });
      },
      {
        threshold: [0, 0.25, 0.5, 0.75]
      }
    );

    items.forEach(function (item) {
      observer.observe(item.el);
    });
  }

  function firePriceSeen() {
    if (state.priceSeen) return;

    var price = extractPriceNumber();

    state.priceSeen = true;
    state.timeToPriceS = nowS();

    capture('pdp price seen', {
      price_displayed: price,
      price_band: getPriceBand(price),
      time_to_price_s: state.timeToPriceS,
      scroll_depth_at_price: getScrollDepth(),
      sections_seen_before_price: Object.keys(state.sectionsSeen).length
    });
  }

  function setupPriceObserver() {
    var priceEl = findElement([
      'product-price',
      '.price',
      '.product__price',
      '.product-price',
      '[data-testid="price"]',
      '[class*="price"]'
    ]);

    if (!priceEl || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            firePriceSeen();
            observer.disconnect();
          }
        });
      },
      {
        threshold: [0.25]
      }
    );

    observer.observe(priceEl);
  }

  function setupScrollMilestones() {
    var ticking = false;

    function check() {
      ticking = false;

      var depth = getScrollDepth();

      state.maxScrollDepth = Math.max(state.maxScrollDepth, depth);

      SCROLL_MILESTONES.forEach(function (milestone) {
        if (
          depth >= milestone &&
          state.scrollMilestonesHit.indexOf(milestone) === -1
        ) {
          state.scrollMilestonesHit.push(milestone);

          capture('pdp scroll milestone', {
            milestone_percent: milestone,
            scroll_depth_percent: depth,
            time_on_page_s: nowS(),
            price_seen: state.priceSeen
          });
        }
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(check);
        }
      },
      { passive: true }
    );

    check();
  }

  function setupAccordionTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;

        var accordion = target.closest(
          'accordion-component, details, .accordion, .product__accordion, collapsible-row'
        );

        if (!accordion) return;

        var label = '';
        var summary = accordion.querySelector('summary, button, [role="button"]');

        if (summary) {
          label = summary.textContent.trim();
        } else {
          label = target.textContent.trim();
        }

        capture('pdp accordion opened', {
          interaction_target: label.slice(0, 80),
          element_tag: accordion.tagName.toLowerCase()
        });
      },
      true
    );
  }

  function setupImageTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;

        var imageTarget = target.closest(
          'media-gallery button, product-gallery button, .product-information__media button, .product-media button, thumbnail-slider button, [data-media-id]'
        );

        if (!imageTarget) return;

        var mediaId =
          imageTarget.getAttribute('data-media-id') ||
          imageTarget.getAttribute('aria-controls') ||
          imageTarget.getAttribute('aria-label') ||
          '';

        capture('pdp image viewed', {
          interaction_target: mediaId,
          element_tag: imageTarget.tagName.toLowerCase()
        });
      },
      true
    );
  }

  function setupVariantTracking() {
    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;

        if (
          !target.closest(
            'variant-picker-component, variant-picker, .variant-picker, .product-form__input, product-form'
          )
        ) {
          return;
        }

        state.variantSelected = true;
        state.variantChangeCount += 1;

        capture('pdp variant selected', {
          variant_value: target.value || target.getAttribute('value') || '',
          variant_name: target.name || target.getAttribute('name') || '',
          variant_change_count: state.variantChangeCount
        });
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;

        var variantButton = target.closest(
          'variant-picker-component button, variant-picker button, .variant-picker button, .product-form__input button, [data-option-value]'
        );

        if (!variantButton) return;

        state.variantSelected = true;
        state.variantChangeCount += 1;

        capture('pdp variant selected', {
          variant_value:
            variantButton.getAttribute('data-option-value') ||
            variantButton.getAttribute('value') ||
            variantButton.textContent.trim(),
          variant_name:
            variantButton.getAttribute('name') ||
            variantButton.getAttribute('aria-label') ||
            '',
          variant_change_count: state.variantChangeCount
        });
      },
      true
    );
  }

  function setupTrustAssetTracking() {
    document.addEventListener(
      'click',
      function (event) {
        var target = event.target.closest('[data-th-trust-asset]');

        if (!target) return;

        capture('pdp trust asset clicked', {
          interaction_target: target.getAttribute('data-th-trust-asset'),
          element_text: target.textContent.trim().slice(0, 120)
        });
      },
      true
    );
  }

  function endSession() {
    if (state.sessionEnded) return;

    state.sessionEnded = true;

    capture('pdp session ended', {
      time_on_page_s: nowS(),
      max_scroll_depth: state.maxScrollDepth,
      scroll_milestones_hit: state.scrollMilestonesHit,
      sections_seen: Object.keys(state.sectionsSeen),
      sections_seen_count: Object.keys(state.sectionsSeen).length,
      price_seen: state.priceSeen,
      time_to_price_s: state.timeToPriceS,
      variant_selected: state.variantSelected,
      variant_change_count: state.variantChangeCount
    });
  }

  function setupSessionEndTracking() {
    window.addEventListener('pagehide', endSession);
    window.addEventListener('beforeunload', endSession);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') {
        endSession();
      }
    });
  }

  function init() {
    log('Initializing PDP tracker', TRACKER_VERSION);

    var sections = getSectionElements();

    setupSectionObserver(sections);
    setupPriceObserver();
    setupScrollMilestones();
    setupAccordionTracking();
    setupImageTracking();
    setupVariantTracking();
    setupTrustAssetTracking();
    setupSessionEndTracking();

    log('Ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();